export default {
  OK: "OK",
  ok: "OK",
  loginFailed: "登录失败,请重试。",
  requestFailed: "请求失败,请检查您的互联网连接。",
  invalidLogin: "无效的用户名或密码。",
  invalidPassword: "此功能已存在。",
  thisFunctionExists: "此功能不允许删除。",
  thisFunctionNotAllowDelete: "此功能不存在。",
  thisFunctionNotExists: "目标功能ID是必需的。",
  targetFunctionIdRequired: "此页面已存在。",
  thisPageExists: "此页面不允许删除。",
  thisPageNotAllowDelete: "此角色已存在。",
  thisRoleExists: "此角色不允许删除。",
  thisRoleNotAllowDelete: "目标角色ID是必需的。",
  targetRoleIdRequired: "无效的参数。",
  invalidParameter: "系统无法处理您的请求。",
  systemError: "SP消息错误(根据错误情况而定)。",
  spErrorMessage: "当前用户是必需的。",
  actionbyRequired: "会话令牌是必需的。",
  sessionTokenRequired: "功能ID是必需的。",
  functionIdRequired: "功能名称是必需的。",
  functionNameRequired: "功能名称是必需的。",
  newFunctionNameRequired: "页面ID是必需的。",
  pageIdRequired: "页面ID是必需的。",
  newPageIdRequired: "页面名称是必需的。",
  newPageNameRequired: "目标页面ID是必需的。",
  targetPageIdRequired: "用户ID是必需的。",
  userIdRequired: "密码是必需的。",
  passwordRequired: "全名是必需的。",
  userNameRequired: "密码必须是6-20个字符,包含数字和字母的组合。",
  passwordValidation: "页码是必需的。",
  pageNumRequired: "页面大小是必需的。",
  pageSizeRequired: "角色ID是必需的。",
  roleIdRequired: "当前密码是必需的。",
  oldPasswordRequired: "用户状态是必需的。",
  userStatusRequired: "角色ID是必需的。",
  newRoleIdRequired: "角色名称是必需的。",
  newRoleNameRequired: "开始日期是必需的。",
  startDateRequired: "结束日期是必需的。",
  endDateRequired: "开始日期大于结束日期。",
  startDateIsGteEndDate: "此角色不存在。",
  thisRoleNotExists: "此页面不存在。",
  thisPageNotExists: "此用户已存在。",
  thisUserExists: "此用户不存在。",
  thisUserNotExists: "您的帐户已被暂停。",
  thisUserBlackListed: "您的帐户已被禁用。",
  thisUserInactive: "您的帐户已被阻止。",
  thisUserBlocked: "您的帐户已被禁用。",
  thisUserNotActive: "无效的页面功能。",
  InvalidPageFunction: "无效的用户！",
  invalidUser: "无效的会话！",
  invalidToken: "无效的会话！",
  NoUserAccessRight: "权限被拒绝！",
  unableSPProcess: "系统无法处理您的请求。",
  connection: "连接错误",
  loginIdRequired: "需要登录 ID。",
  loginNameRequired: "需要登录名称。",
  targetLoginIdRequired: "需要目标登录 ID。",
  newHostIdRequired: "需要主机 ID。",
  newLoginNameRequired: "需要登录名称。",
  loginDisabledRequired: "需要登录已禁用。",
  thisLoginExists: "此登录已存在。",
  thisLoginNotExists: "此登录不存在。",
  sourceAccountIdRequired: "需要源帐户 ID。",
  targetAccountIdRequired: "需要目标帐户 ID。",
  authTokenRequired: "需要身份验证令牌。",
  accountIdRequired: "需要帐户 ID。",
  minDepositRequired: "需要最低存款。",
  minWithdrawalRequired: "需要最低提款。",
  minBalanceRequired: "最低余额要求。",
  invalidSourceAccountId: "无效的源帐户 ID。",
  invalidTargetAccountId: "无效的目标帐户 ID。",
  subLoginIdRequired: "需要子登录 ID。",
  invalidAccountId: "无效的帐户 ID。",
  invalidSubLoginId: "无效的子登录 ID。",
  parentIdRequired: "需要父 ID。",
  invalidParentId: "无效的父 ID。",
  newLoginIdRequired: "需要新登录 ID。",
  newPasswordRequired: "需要新密码。",
  securityTagRequired: "需要安全标签。",
  securityCodeRequired: "需要安全代码。",
  authorityOptionRequired: "需要权限选项。",
  profileIdRequired: "需要个人资料 ID。",
  newStatusRequired: "需要新状态。",
  amountRequired: "需要金额。",
  bankIdRequired: "需要银行 ID。",
  bankAccNoRequired: "需要银行帐户号码。",
  bankAccHolderRequired: "需要银行帐户持有人。",
  newBankIdRequired: "需要新银行 ID。",
  newBankAccNoRequired: "需要新银行帐户号码。",
  newBankAccHolderRequired: "需要新银行帐户持有人。",
  bankNameRequired: "需要银行名称。",
  incomingAmountThresholdRequired: "需要收款金额阈值。",
  incomingFrequencyThresholdRequired: "需要收款频率阈值。",
  outgoingAmountThresholdRequired: "需要付款金额阈值。",
  outgoingFrequencyThresholdRequired: "需要付款频率阈值。",
  accountBalanceRequired: "需要帐户余额。",
  contactPhoneRequired: "需要联系电话。",
  memberIdRequired: "需要会员 ID。",
  referrerCodeRequired: "需要推荐代码。",
  referrerIdRequired: "需要推荐人 ID。",
  referrerRequired: "需要推荐人。",
  packageIdRequired: "需要套餐 ID。",
  fullNameMinThreeChar: "全名必须至少有 3 个字符。",
  accountIdMinThreeChar: "帐户 ID 必须至少有 3 个字符。",
  nicknameMinThreeChar: "昵称必须至少有 3 个字符。",
  searchCriteriaRequired: "需要搜索条件。",
  reviewIdRequired: "需要审核 ID。",
  auditByRequired: "需要审核者。",
  accountTypeRequired: "需要帐户类型。",
  invalidAccountType: "无效的帐户类型。",
  notMasterAccount: "登录帐户不是主帐户。",
  ticketIdRequired: "需要工单 ID。",
  affiliateIdRequired: "需要联盟 ID。",
  workingMonthRequired: "需要工作月份。",
  commPackageRequired: "需要佣金套餐。",
  remarkRequired: "需要备注。",
  workingDateRequired: "需要工作日期。",
  couponCodeRequired: "需要优惠码。",
  couponNameRequired: "需要优惠码名称。",
  couponQuotaRequired: "需要优惠码配额。",
  claimTypeRequired: "需要索赔类型。",
  minDepositRequired: "需要最低存款。",
  bonusRateRequired: "需要奖金比例。",
  rolloverRequired: "需要滚动要求。",
  criteriaRequired: "需要条件。",
  allocatedRequired: "需要已分配。",
  gameCodeRequired: "需要游戏代码。",
  gameCountRequired: "需要游戏计数。",
  capLimitAmtRequired: "需要封顶金额。",
  tacNotValidate: "TAC 代码尚未验证。",
  sourceMinTwoChar: "源必须至少有 2 个字符。",
  mediumMinTwoChar: "媒体必须至少有 2 个字符。",
  campaignMinTwoChar: "活动必须至少有 2 个字符。",
  termMinTwoChar: "术语必须至少有 2 个字符。",
  contentMinTwoChar: "内容必须至少有 2 个字符。",
  searchByMemberRequired: "需要按会员搜索。",
  idRequired: "需要 ID。",
  searchByIdRequired: "需要按 ID 搜索。",
  quantityRequired: "需要数量。",
  logIdStrRequired: "需要日志 ID 字符串。",
  onlyAllowRejectDeposit: "仅允许拒绝存款工单。",
  socialPlatformRequired: "需要社交平台。",
  securityDisabledRequired: "需要禁用安全。",
  groupIdRequired: "需要群组 ID。",
  groupNameRequired: "需要群组名称。",
  bankAccTypeRequired: "需要银行帐户类型。",
  bankGroupIdRequired: "需要银行群组 ID。",
  isPublicRequired: "是否需要公共信息。",
  isDefaultRequired: "是否需要默认设置。",
  bankModeRequired: "银行模式是必需的。",
  recipientBankIdRequired: "接收方银行 ID 是必需的。",
  recipientBankAccNoRequired: "接收方银行帐户号码是必需的。",
  campaignIdRequired: "需要活动 ID。",
  campaignNameRequired: "需要活动名称。",
  rolloverNotRequired: "不需要滚动。",
  criteriaNotRequired: "不需要条件。",
  maxBonusRequired: "需要最大奖金。",
  withholdBonusRequired: "需要保留奖金。",
  withholdAmountRequired: "需要保留金额。",
  maxWithdrawAmountRequired: "需要最大提款金额。",
  startTimeRequired: "需要开始时间。",
  endTimeRequired: "需要结束时间。",
  mondayRequired: "需要星期一。",
  tuesdayRequired: "需要星期二。",
  wednesdayRequired: "需要星期三。",
  thursdayRequired: "需要星期四。",
  fridayRequired: "需要星期五。",
  saturdayRequired: "需要星期六。",
  sundayRequired: "需要星期天。",
  providerCodeRequired: "需要提供者代码。",
  packageRequired: "需要套餐。",
  settingKeyRequired: "需要设置键。",
  settingValueRequired: "需要设置值。",
  bonusNameRequired: "需要奖金名称。",
  bonusValueRequired: "需要奖金值。",
  baseAmountRequired: "需要基础金额。",
  bankGroupRequired: "需要银行群组。",
  promotionGroupRequired: "需要促销群组。",
  withdrawalLimitRequired: "需要提款限制。",
  vipIdRequired: "需要 VIP ID。",
  limitIdRequired: "需要限制 ID。",
  limitNameRequired: "需要限制名称。",
  dailyAmountRequired: "需要每日金额。",
  dailyFrequencyRequired: "需要每日频率。",
  selfRebateRateRequired: "需要自我返利率。",
  downlineRebateRateRequired: "需要下线返利率。",
  senderBankIdRequired: "需要发送方银行 ID。",
  senderBankAccNoRequired: "需要发送方银行帐号。",
  depositMethodRequired: "需要存款方式。",
  depositAmountRequired: "需要存款金额。",
  targetBankIdRequired: "需要目标银行 ID。",
  targetBankAccNoRequired: "需要目标银行帐户号码。",
  targetBankAccHolderRequired: "需要目标银行帐户持有人。",
  refNoRequired: "需要参考号。",
  depositDateRequired: "需要存款日期。",
  requestTypeRequired: "需要请求类型。",
  resultIdRequired: "需要结果 ID。",
  referralCodeRequired: "需要推荐代码。",
  promotionIdRequired: "需要促销 ID。",
  promotionNameRequired: "需要促销名称。",
  bonusAmountRequired: "需要奖金金额。",
  matchIdRequired: "需要匹配 ID。",
  homeScoreRequired: "需要主队分数。",
  awayScoreRequired: "需要客队分数。",
  createdByRequired: "需要创建者。",
  pinRequired: "需要 PIN。",
  homeTeamRequired: "需要主队。",
  awayTeamRequired: "需要客队。",
  gameIdRequired: "需要游戏 ID。",
  contactEmailRequired: "需要联系电子邮件。",
  rtpRequired: "需要 RTP。",
  minFTDAmtNumOnly: "最低首次存款金额只接受数字。",
  maxFTDAmtNumOnly: "最大首次存款金额只接受数字。",
  crmBasicCriteriaRequired: "会员 ID / 联系电话 / 联系电子邮件 / 注册日期 / 上次登录日期是必需的。",
  verifiedDateRangeAllowThreeMonths: "注册日期范围只允许选择最多 3 个月。",
  lastLoginDateRangeAllowThreeMonths: "上次登录日期范围只允许选择最多 3 个月。",
  depositDateRangeAllowThreeMonths: "存款日期范围只允许选择最多 3 个月。",
  ftdDateRangeAllowThreeMonths: "首次存款日期范围只允许选择最多 3 个月。",
  ltdDateRangeAllowThreeMonths: "持续存款日期范围只允许选择最多 3 个月。",
  lastLoginDateEarlierThanVerifiedDate: "上次登录日期早于注册日期。",
  depositDateEarlierThanVerifiedDate: "存款日期早于注册日期。",
  ftdDateEarlierThanVerifiedDate: "首次存款日期早于注册日期。",
  ltdDateEarlierThanVerifiedDate: "持续存款日期早于注册日期。",
  verifiedFromRequired: "需要注册起始日期。",
  verifiedToRequired: "需要注册结束日期。",
  lastLoginFromRequired: "需要上次登录起始日期。",
  lastLoginToRequired: "需要上次登录结束日期。",
  depositFromRequired: "需要存款起始日期。",
  depositToRequired: "需要存款结束日期。",
  ftdFromRequired: "需要首次存款起始日期。",
  ftdToRequired: "需要首次存款结束日期。",
  ltdFromRequired: "需要持续存款起始日期。",
  ltdToRequired: "需要持续存款结束日期。",
  failedToLaunchPaymentGateway: "无法启动支付网关。",
  invalidTicket: "无效的工单。",
  requestTooFrequent: "请求太频繁,请稍后重试。",
  bonusListSizeRequired: "需要奖金列表大小。",
  failedToGetSettingKey: "无法获取设置键。",
  memberListRequired: "需要会员列表。",
  paymentModeRequired: "需要付款方式。",
  providerGroupRequired: "需要提供者群组。",
  ipAddressRequired: "需要 IP 地址。",
  alreadyHitRequired: "已经命中是必需的。",
  freebiesIdStrRequired: "需要免费奖品 ID 字符串。",
  bannerIdRequired: "需要横幅 ID。",
  directionRequired: "需要方向。",
  itemOrderRequired: "需要项目顺序。",
  enTitleRequired: "需要EN标题。",
  enBodyRequired: "需要EN正文。",
  enImageUrlRequired: "需要EN图片网址。",
  pageNameRequired: "需要页面名称。",
  enImageUrlDesktopRequired: "需要EN桌面图片网址。",
  enAltRequired: "需要EN图像替代文本。",
  enHrefRequired: "需要EN链接网址。",
  targetWindowRequired: "需要目标窗口。",
  loginRequiredRequired: "需要登录要求。",
  bannerTypeRequired: "需要横幅类型。",
  surveyIdRequired: "需要调查ID。",
  notAdminAccount: "登录帐户不是管理员。",
  questionRequired: "需要问题。",
  resubmitTicketRequired: "需要重新提交工单。",
  notSupportedBank: "不支持银行。",
  amountLessThanMin: "金额低于最低限额。",
  amountGreaterThanMax: "金额大于最大限额。",
  seqRequired: "需要顺序。",
  maxWithdrawMultipleRequired: "需要最大提款乘数。",
  withtholdBonusAndAmountGreaterThanZero: "预扣奖金和预扣金额不能同时大于零。",
  maxWithdrawMultipleAndAmountGreaterThanZero: "最大提款乘数和最大提款金额不能同时大过零。",
  nbRedepositRequired: "需要无奖金重新存款。",
  loginIpRequired: "需要登录IP。",
  ticketIdRequired: "需要工单ID。",
  minLimitRequired: "需要最小限额。",
  maxLimitRequired: "需要最大限额。",
  commSportsRequired: "需要体育博彩佣金。",
  commSlotsRequired: "需要老虎机佣金。",
  commLivecasinoRequired: "需要真人娱乐佣金。",
  commCockfightRequired: "需要斗鸡佣金。",
  commOthersRequired: "需要其他佣金。",
  settlementTypeRequired: "需要结算类型。",
  carryOverRequired: "需要结转。",
  roundIdRequired: "需要回合ID。",
  failedToGetUnfinishRound: "未能获取未完成的回合。",
  failedToCancelUnfinishRound: "未能取消未完成的回合。",
  totalRoundRequired: "需要总回合。",
  betValueRequired: "需要投注值。",
  lineBetRequired: "需要线注。",
  maxWinAmountRequired: "需要最大赢奖金额。",
  failedToCreateFreeRound: "未能创建免费的回合。",
  failedToGetFreeRound: "未能获取免费的回合。",
  failedToGetFreeRoundGameList: "未能获取免费的回合游戏列表。",

  serverBusy: "服务器忙,请稍后重试。",

  isRequired: "请输入{fname}。",
  isMinValue: "{fname}必须至少有{fvalue}。",
  isMaxValue: "{fname}必须小于或等于{fvalue}。",
  isMinLength: "{fname}必须至少有{fvalue}个字符。",
  isMaxLength: "{fname}必须小于或等于{fvalue}个字符。",
  isAlpha: "{fname}只接受字母。",
  isAlphaNum: "{fname}只接受字母数字。",
  isNumeric: "{fname}只接受数字。",
  isEmail: "{fname}只接受有效的电子邮件地址。",
  isIpAddress: "{fname}只接受有效的IPv4地址。",
  isSameAs: "{fname}必须与{fname2}相同。",
  isUrl: "{fname}只接受URL。",
  containAlphaNum: "{fname}必须至少包含一个字母和一个数字。",
  alphaNumWithSpace: "{fname}只接受字母数字。",
  isDecimal: "{fname}只接受数字。",
  isInteger: "{fname}只接受整数。",
  selectOption: "请选择{fname}。",
  notSameAs: "{fname}和{fname2}不能相同。",
  dateRangeAllowOneMonth: "日期范围仅允许选择最多1个月。",
  dateRangeAllowOneYear: "日期范围仅允许选择最多1年。",
  dateRangeAllow24Hours: "日期范围仅允许选择最多24小时。",
  greaterThanZero: "{fname}必须大于零。",
  atLeastOneAuthority: "必须至少选择一个权限。",
  BLOCK: "您的帐户已被阻止。",
  SUSPEND: "您的帐户已被暂停。",
  CLOSE: "您的帐户已关闭。",
  RESETL: "您的帐户已重置。",
  atLeastOneProvider: "必须至少选择一个提供者。",
  failedToGetResultUrl: "获取结果网址失败。",
  fileSizeValidation: "太大,最大允许大小为1MB。",
  atLeastOnePaymentOption: "必须至少选择一个付款选项。",
  dateRangeAllow31Days: "日期范围仅允许选择最多31天。",
  dateRangeAllow31Months: "日期范围仅允许选择最多31个月。",
  dateRangeAllow31Years: "日期范围仅允许选择最多31年。",
  invalidCategory: "无效的类别",

  must_enable_at_least_one: "必须启用至少一个选项。",
  insufficient_balance: "余额不足。",
  source_account_id_required: "需要源帐户ID。",
  source_account_id_not_exists: "源帐户ID不存在。",
  source_account_inactive: "源帐户不活跃。",
  target_account_id_required: "需要目标帐户ID。",
  target_account_id_not_exists: "目标帐户ID不存在。",
  target_account_inactive: "目标帐户不活跃。",
  target_account_not_exists: "目标帐户不存在。",
  account_id_required: "需要帐户ID。",
  account_not_exists: "帐户不存在。",
  sub_login_id_required: "需要子登录ID。",
  login_id_required: "需要登录ID。",
  login_id_not_exists: "登录ID不存在。",
  profile_not_exists: "档案不存在。",
  account_inactive: "帐户不活跃。",
  password_required: "需要密码。",
  invalid_password: "无效的密码。",
  permission_denied: "权限被拒绝。",
  min_deposit_required: "需要最低存款。",
  min_withdrawal_required: "需要最低提款。",
  min_balance_required: "需要最低余额。",
  account_not_blocked: "帐户未被阻止。",
  parent_id_not_exists: "父ID不存在。",
  parent_id_required: "需要父ID。",
  incorrect_parent: "不正确的父ID。",
  not_blocked_account: "不是被阻止的帐户。",
  target_profile_not_exists: "目标档案不存在。",
  self_operate_required: "需要自助操作。",
  parent_not_exists: "父母不存在。",
  account_id_exists: "帐户ID存在。",
  new_login_id_required: "需要新登录ID。",
  new_password_required: "需要新密码。",
  security_tag_required: "需要安全标签。",
  security_code_required: "需要安全代码。",
  secondary_account_exists: "存在次要帐户。",
  new_login_id_exists: "新登录ID已存在。",
  authority_option_required: "需要权限选项。",
  audit_by_required: "需要审核者。",
  bank_id_required: "需要银行ID。",
  bank_acc_no_required: "需要银行帐户号码。",
  bank_acc_holder_required: "需要银行帐户持有人。",
  new_bank_id_required: "需要新银行ID。",
  new_bank_acc_no_required: "需要新银行帐户号码。",
  new_bank_acc_holder_required: "需要新银行帐户持有人。",
  bank_name_required: "需要银行名称。",
  amount_required: "需要金额。",
  bank_account_not_exists: "银行帐户不存在。",
  member_not_exists: "会员不存在。",
  member_account_inactive: "会员帐户不活跃。",
  member_wallet_not_exists: "会员钱包不存在。",
  start_date_gt_end_date: "开始日期大于结束日期。",
  start_date_required: "需要开始日期。",
  end_date_required: "需要结束日期。",
  bank_acc_type_required: "需要银行帐户类型。",
  incoming_amount_threshold_required: "需要收款金额阈值。",
  incoming_frequency_threshold_required: "需要收款频率阈值。",
  outgoing_amount_threshold_required: "需要付款金额阈值。",
  outgoing_frequency_threshold_required: "需要付款频率阈值。",
  account_balance_required: "需要帐户余额。",
  bank_account_exists: "银行帐户存在。",
  bank_member_exists: "银行会员存在。",
  no_changes: "没有更改。",
  bonus_name_required: "需要奖金名称。",
  bonus_value_required: "需要奖金值。",
  criteria_required: "需要标准。",
  rollover_required: "需要滚动。",
  remark_required: "需要备注。",
  invalid_criteria: "无效的标准。",
  ongoing_promotion: "进行中的促销。",
  profile_inactive: "档案不活跃。",
  parent_account_not_exists: "父帐户不存在。",
  parent_account_inactive: "父帐户不活跃。",
  parent_profile_not_exists: "父档案不存在。",
  parent_profile_inactive: "父档案不活跃。",
  profile_id_required: "需要档案ID。",
  incorrect_password: "不正确的密码。",
  base_amount_required: "需要基础金额。",
  bonus_amount_required: "需要奖金金额。",
  no_ongoing_promo: "没有正在进行的促销。",
  package_id_required: "需要套餐ID。",
  promo_package_not_exists: "促销套餐不存在。",
  promo_package_inactive: "促销套餐不活跃。",
  promo_package_downloaded: "促销套餐已下载。",
  promo_id_required: "需要促销ID。",
  new_status_required: "需要新状态。",
  invalid_security_code: "无效的安全代码。",
  auth_token_required: "需要身份验证令牌。",
  auth_status_required: "需要身份验证状态。",
  invalid_session: "无效的会话。",
  session_expired: "会话已过期。",
  action_required: "需要操作。",
  invalid_account_status: "无效的帐户状态。",
  ticket_id_required: "需要工单ID。",
  ticket_not_exists: "工单不存在。",
  ticket_processed: "工单已处理。",
  min_deposit_not_met: "未达到最低存款要求。",
  invalid_promo_package: "无效的促销套餐。",
  promo_min_deposit_not_met: "未达到促销最低存款要求。",
  claim_promo_only_once_a_day: "促销只允许每天申领一次。",
  first_deposit_met: "未达到首次存款促销要求。",
  newbie_not_met: "新手促销要求未满足。",
  claim_promo_only_once: "促销只允许申领一次。",
  multiplier_not_found: "未找到倍增器",
  inner_catch: "内部捕获。",
  sender_bank_id_required: "需要发送方银行ID。",
  sender_bank_acc_no_required: "需要发送方银行帐号。",
  sender_bank_acc_holder_required: "需要发送方银行帐户持有人。",
  min_withdrawal_not_met: "未满足最低提款金额。",
  promotion_requirement_not_met: "未满足促销要求。",
  invalid_promotion: "无效的促销。",
  fund_transfer_record_not_exists: "资金转移记录不存在。",
  point_transfer_record_not_exists: "积分转移记录不存在。",
  working_date_required: "需要工作日期。",
  contact_phone_required: "需要联系电话。",
  vip_mode_required: "需要VIP模式。",
  invalid_vip_mode: "无效的VIP模式。",
  level_1_requirement_required: "需要一级要求。",
  level_1_multp_required: "需要一级倍增器。",
  level_2_requirement_required: "需要二级要求。",
  level_2_multp_required: "需要二级倍增器。",
  level_3_requirement_required: "需要三级要求。",
  level_3_multp_required: "需要三级倍增器。",
  level_4_requirement_required: "需要四级要求。",
  level_4_multp_required: "需要四级倍增器。",
  level_5_requirement_required: "需要五级要求。",
  level_5_multp_required: "需要五级倍增器。",
  level_6_requirement_required: "需要六级要求。",
  level_6_multp_required: "需要六级倍增器。",
  level_7_requirement_required: "需要七级要求。",
  level_7_multp_required: "需要七级倍增器。",
  already_setup: "已设置。",
  vip_not_exists: "VIP不存在。",
  ibank_deposit: "权限被拒绝。",
  sub_profile_inactive: "子档案不活跃。",
  referrer_code_required: "需要引荐人代码。",
  referrer_not_exists: "引荐人不存在。",
  min_balance_not_met: "未满足最低余额要求。",
  search_criteria_required: "需要搜索条件。",
  review_id_required: "需要审查ID。",
  bank_account_inactive: "银行帐户不活跃。",
  pending_result_in_game: "游戏中的待处理结果。",
  comm_package_required: "需要佣金套餐。",
  comm_package_not_exists: "佣金套餐不存在。",
  inactive_comm_package: "佣金套餐不活跃。",
  tac_not_validate: "TAC代码尚未验证。",
  invalid_amount: "无效的金额。",
  affiliate_id_required: "需要联盟ID。",
  member_id_required: "需要会员ID。",
  coupon_code_required: "需要优惠券代码。",
  coupon_name_required: "需要优惠券名称。",
  coupon_quota_required: "需要优惠券配额。",
  coupon_code_unavailable: "优惠券配额不可用。",
  coupon_exists: "优惠券已存在。",
  allocated_required: "需要已分配。",
  claim_type_required: "需要领取类型。",
  bonus_rate_required: "需要奖金比率。",
  referrer_required : "需要引荐人。",
  id_required: "需要ID。",
  invalid_contact_email: "无效的联系电子邮件。",
  log_id_required: "需要日志ID。",
  log_not_exists: "日志不存在。",
  account_exists: "帐户已存在。",
  social_platform_required: "需要社交平台。",
  sub_account_exists: "子帐户已存在。",
  group_id_required: "需要组ID。",
  bank_not_exists: "银行不存在。",
  bank_group_not_exists: "银行组不存在。",
  bank_account_group_exists: "银行帐户组不存在。",
  is_public_required: "需要是否公开。",
  group_name_required: "需要组名。",
  is_default_required: "需要是否默认。",
  bank_group_exists: "银行组已存在。",
  bank_member_not_exists: "银行会员不存在。",
  bank_inactive: "银行不活跃。",
  banking_mode_required: "银行模式是必需的。",
  bank_setting_not_exists: "银行设置不存在。",
  working_month_required: "需要工作月份。",
  recipient_bank_id_required: "需要受益银行ID。",
  recipient_bank_acc_no_required: "需要受益银行帐号。",
  recipient_bank_acc_holder_required: "需要受益银行帐户持有人。",
  provider_code_required: "需要提供者代码。",
  package_required: "需要套餐。",
  bet_limit_not_exists: "投注限制不存在。",
  withhold_bonus_required: "需要保留奖金。",
  withhold_amount_required: "需要保留金额。",
  max_withdraw_amount_required: "需要最大提款金额。",
  campaign_id_required: "需要活动ID。",
  campaign_name_required: "需要活动名称。",
  campaign_id_exists: "活动ID已存在。",
  campaign_details_required: "需要活动详细信息。",
  promotion_not_exists: "促销不存在。",
  rollover_and_criteria_not_required: "不需要滚动和标准。",
  campaign_id_not_exists: "活动ID不存在。",
  max_bonus_required: "需要最大奖金。",
  start_time_gte_end_time: "开始时间大于或等于结束时间。",
  monday_required: "需要星期一。",
  tuesday_required: "需要星期二。",
  wednesday_required: "需要星期三。",
  thursday_required: "需要星期四。",
  friday_required: "需要星期五。",
  saturday_required: "需要星期六。",
  sunday_required: "需要星期日。",
  coupon_code_exists: "优惠券代码已存在。",
  invalid_claim_type: "无效的领取类型。",
  invalid_working_month: "无效的工作月份。",
  invalid_date_range: "无效的日期范围。",
  result_id_required: "需要结果ID。",
  setting_key_required: "需要设置键。",
  setting_value_required: "需要设置值。",
  contact_phone_exists: "联系电话已存在。",
  bank_group_required: "银行组是必需的。",
  promotion_group_required: "促销组是必需的。",
  withdrawal_limit_required: "需要提款限额。",
  withdrawal_limit_not_exists: "提款限额不存在。",
  vip_id_required: "需要VIP ID。",
  promotion_id_required: "需要促销ID。",
  promotion_name_required: "需要促销名称。",
  promotion_exists: "促销已存在。",
  promotion_group_exists: "促销组已存在。",
  promotion_group_not_exists: "促销组不存在。",
  setting_not_set: "设置未设置。",
  start_date_gte_end_date: "开始日期大于或等于结束日期。",
  referral_code_required: "需要推荐代码。",
  security_disabled_required: "需要禁用安全性。",
  deposit_amount_required: "需要存款金额。",
  target_bank_id_required: "需要目标银行ID。",
  target_bank_acc_no_required: "需要目标银行帐号。",
  target_bank_acc_holder_required: "需要目标银行帐户持有人。",
  ref_no_required: "需要参考号。",
  deposit_date_required: "需要存款日期。",
  deposit_method_required: "需要存款方式。",
  client_ip_required: "需要客户IP。",
  promotion_not_available: "促销不可用。",
  coupon_not_available: "优惠券不可用。",
  request_type_required: "需要请求类型。",
  self_rebate_rate_required: "需要自我返点率。",
  downline_rebate_rate_required: "需要下线返点率。",
  vip_provider_not_exists: "VIP提供者不存在。",
  limit_name_required: "需要限制名称。",
  daily_amount_required: "需要每日金额。",
  daily_frequency_required: "需要每日频率。",
  limit_id_required: "需要限制ID。",
  bank_account_required: "需要银行帐户。",
  bank_account_group_not_exists: "银行帐户组不存在。",
  rollover_and_criteria_required: "需要滚动和标准。",
  start_time_required: "需要开始时间。",
  member_details_required: "需要会员详细信息。",
  sub_account_not_exists: "子帐户不存在。",
  promotion_group_norm_exists: "推广组规范存在。",
  promotion_group_norm_not_exists: "推广组规范不存在。",
  withdrawal_limit_exists: "提款限额存在。",
  Match_not_yet_closed: "比赛尚未关闭。",
  Match_not_exists: "比赛不存在。",
  Match_already_entered_result: "比赛已输入结果。",
  Insert_score_failed: "插入得分失败。",
  Insert_Failed_Log: "插入失败日志。",
  Invalid_Pin: "无效的PIN码。",
  This_match_is_not_allowed_to_update: "不允许更新此比赛。",
  Update_Failed_Log: "更新失败日志。",
  Update_Failed_Match: "更新失败比赛。",
  Update_Failed_Bet: "更新失败投注。",
  success: "成功。",
  Team_Not_Exists: "球队不存在。",
  Match_Not_Allowed_to_Update: "不允许更新比赛。",
  Update_Failed: "更新失败。",
  game_id_required: "需要游戏ID。",
  provider_code_not_exists: "提供者代码不存在。",
  contact_email_exists: "联系电子邮件已存在。",
  contact_email_required: "需要联系电子邮件。",
  rtp_required: "需要RTP。",
  redeposited_ticket: "门票已经重新存款。",
  freebies_id_required: "需要免费赠品ID。",
  account_id_not_exists: "帐户ID不存在。",
  sender_bank_not_exists: "发件银行不存在。",
  recipient_bank_not_exists: "收件银行不存在。",
  start_time_required: "需要开始时间。",
  end_time_required: "需要结束时间。",
  invalid_ftd_min: "无效的FTD最小值。",
  invalid_ftd_max: "无效的FTD最大值。",
  ftd_min_gt_ftd_max: "FTD最小值大于FTD最大值。",
  unknown_error: "未知错误。",
  question_exists: "问题已存在。",
  question_not_exists: "问题不存在。",
  first_deposit_not_met: "首次存款未达标。",
  newbie_not_met: "新手未达标。",
  question_required: "需要问题。",
  survey_id_required: "需要调查ID。",
  title_required: "需要标题。",
  body_required: "需要正文。",
  item_order_required: "需要图像顺序。",
  image_url_required: "需要图像网址。",
  banner_id_required: "需要横幅ID。",
  direction_required: "需要方向。",
  default_order_required: "需要默认顺序。",
  alt_required: "需要Alt文本。",
  href_required: "需要Href。",
  target_window_required: "需要目标窗口。",
  login_required_required: "需要登录。",
  active_from_required: "需要生效日期。",
  active_to_required: "需要到期日期。",
  banner_type_required: "需要横幅类型。",
  page_name_required: "需要页面名称。",
  page_id_required: "需要页面ID。",
  image_exists: "图像存在。",
  invalid_order: "无效的顺序。",
  banner_not_exists: "横幅不存在。",
  image_desktop_exists: "图像桌面存在。",
  image_mobile_exists: "图像移动存在。",
  invalid_banner_type: "无效的横幅类型。",
  page_name_exists: "页面名称已存在。",
  page_not_exists: "页面不存在。",
  exceeded_size_limit: "超过大小限制。",
  tac_is_valid: "TAC有效。",
  invalid_tac: "无效的TAC。",
  tac_expired: "TAC已过期。",
  payment_mode_not_exists: "付款方式不存在。",
  must_enable_at_least_one: "必须至少启用一个。",
  payment_option_provider_not_exists: "付款选项提供者不存在。",
  ip_address_exists: "IP地址已存在。",
  status_required: "必须提供状态。",
  active_from_gt_active_to: "生效日期大于到期日期。",
  verified_from_gt_verified_to: "从验证开始大于验证结束。",
  last_login_from_gt_last_login_to: "从最后登录开始大于最后登录结束。",
  deposit_from_gt_deposit_to: "从存款开始大于存款结束。",
  ftd_from_gt_ftd_to: "从FTD开始大于FTD结束。",
  ltd_from_gt_ltd_to: "从LTD开始大于LTD结束。",
  invalid_verified_date_range: "无效的验证日期范围。",
  invalid_last_login_date_range: "无效的最后登录日期范围。",
  verified_date_range_gt_last_login_date_range: "验证日期范围大于最后登录日期范围。",
  invalid_deposit_date_range: "无效的存款日期范围。",
  verified_date_range_gt_deposit_date_range: "验证日期范围大于存款日期范围。",
  invalid_ftd_date_range: "无效的FTD日期范围。",
  verified_date_range_gt_ftd_date_range: "验证日期范围大于FTD日期范围。",
  invalid_ltd_date_range: "无效的LTD日期范围。",
  verified_date_range_gt_ltd_date_range: "验证日期范围大于LTD日期范围。",
  ftd_date_range_gt_ltd_date_range: "FTD日期范围大于LTD日期范围。",
  invalid_deposit_count: "无效的存款计数。",
  invalid_deposit_amount: "无效的存款金额。",
  invalid_min_day_no_login: "无效的最小不登录天数。",
  invalid_min_day_no_deposit: "无效的最小不存款天数。",
  filter_required: "需要筛选器。",
  ip_address_required: "需要IP地址。",
  member_list_required: "需要会员列表。",
  payment_mode_required: "需要付款方式。",
  provider_group_required: "需要提供者组。",
  invalid_bank_id: "无效的银行ID。",
  bank_member_inactive: "银行会员不活跃。",
  invalid_ticket_id: "无效的工单 ID。",
  settlement_type_required: "需要结算类型。",
  carry_over_required: "需要结转。",
  comm_sports_required: "需要体育博彩佣金。",
  comm_slots_required: "需要老虎机佣金。",
  comm_livecasino_required: "需要真人娱乐佣金。",
  comm_cockfight_required: "需要斗鸡佣金。",
  comm_others_required: "需要其他佣金。",
  invalid_settlement_type: "无效的结算类型。",
  application_processed: "申请已处理。",
  account_not_block: "帐户未被阻止。",
  invalid_status: "无效的状态。",
  application_pending: "待处理申请。",
  upline_inactive: "上线不活跃。",
  full_name_required: "需要全名。",
  invalid_bank_ida: "无效的银行ID。",
  carry_over_not_exists: "结转不存在。",
  parent_comm_not_exists: "上线佣金不存在。",
  comm_sports_exceeded_parent: "体育博彩佣金超过上线。",
  comm_slots_exceeded_parent: "老虎机佣金超过上线。",
  comm_livecasino_exceeded_parent: "真人娱乐佣金超过上线。",
  comm_cockfight_exceeded_parent: "斗鸡佣金超过上线。",
  comm_others_exceeded_parent: "其他佣金超过上线。",
  setting_not_exists: "设置不存在。",
  settlement_type_not_exists: "结算类型不存在。",
  previous_ticket_status_not_exists: "前工单状态不存在。",
  resubmit_ticket_required: "需要重新提交工单。",
  comm_not_exists: "佣金不存在。",
  affiliate_code_required: "需要联盟代码。",
  affiliate_exists: "联盟已经存在。",
};
